"use client";

import React, { useEffect, useState } from "react";

import { StoryJson } from "@/types/Story.type";
import { SectionNMagazineJson } from "@/types/Setting.type";
import { StoryCollectionJson } from "@/types/StoryCollection.type";

import NBackLink from "./NBackLink";
import NArticleCard from "./NArticleCard";
import LinkElement from "@/components/LinkElement";
import DataEmpty from "~components/empty/DataEmpty";
import NCollectionCard from "~components/blog/NCollectionCard";
import LoadMoreButton from "@/app/blogs/_components/LoadMoreButton";
import ArticleListSkeleton from "~components/skeleton/ArticleListSkeleton";
import { useAppSelector } from "@/redux/hook";

type Props = {
	menu: SectionNMagazineJson[];
	dataType: string;
	data: StoryJson[] | StoryCollectionJson[];
	total: number;
	limit: number;
	link: string;
	handle: string;
	pathname: string;
	showBackLink?: boolean;
	showLoadMoreBtn?: boolean;
	scroll?: boolean;
};

export default function NMainMenuV2({
	menu,
	dataType,
	data,
	total,
	limit,
	link,
	handle,
	pathname,
	showBackLink = false,
	showLoadMoreBtn = false,
	scroll = false,
}: Props) {
	//states
	const device = useAppSelector((state) => state.ShopReducer.device);
	const [open, setOpen] = useState<boolean>(device === "mobile" ? false : true);

	const [loading, setLoading] = useState<boolean>(false);
	const [selected, setSelected] = useState<string>(handle);
	const [dataChange, setDataChange] = useState<
		StoryJson[] | StoryCollectionJson[]
	>([]);

	//
	useEffect(() => {
		dataType === "collection_story"
			? setDataChange(data as StoryCollectionJson[])
			: setDataChange(data as StoryJson[]);

		setLoading(false);
	}, [handle, limit, pathname]);

	return (
		<>
			{menu.length > 0 && (
				<div className="w-full flex flex-col justify-center items-center">
					<div
						className={`w-full h-[40px] flex md:hidden items-center justify-center text-sm text-gray-500 uppercase bg-gray-200`}
						onClick={() => setOpen(!open)}>
						menu
					</div>
					<div
						className={`${
							open ? "max-h-[500px]" : "max-h-0"
						} w-full overflow-hidden transition-max-height duration-500 flex flex-col md:flex-row items-center justify-center md:gap-8 mb-4 md:mb-10`}>
						{menu.map((item: SectionNMagazineJson, index: number) => (
							<LinkElement
								href={`${pathname}?key=${
									item.dataSource.params.collection_id ||
									item.dataSource.params.tags
								}&handle=${item.handle}&type=${item.type}`}
								scroll={false}
								key={index}
								className={`w-full md:w-fit  flex md:block items-center justify-center text-sm md:text-base text-gray-500 uppercase ${
									item.handle === selected
										? "font-bold text-white md:text-gray-500 bg-gray-500 md:bg-transparent"
										: "bg-gray-200 md:bg-transparent"
								}`}>
								<span
									onClick={() => {
										setSelected(item.handle);
										setLoading(true);
									}}>
									{item.title}
								</span>
							</LinkElement>
						))}
					</div>
				</div>
			)}
			{menu.length > 0 && showBackLink && (
				<div className="w-full flex items-start">
					<NBackLink />
				</div>
			)}
			<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-6 md:gap-4">
				{menu.length > 0 && loading ? (
					<ArticleListSkeleton itemRender={{ desktop: 8, mobile: 4 }} />
				) : (
					<>
						{dataChange.length > 0 ? (
							<>
								{dataType === "collection_story" ? (
									<>
										{dataChange.map((item: any, index: number) => (
											<NCollectionCard
												data={item as StoryCollectionJson}
												key={index}
												classNameImage="w-[187px] md:w-[293px] h-[187px] md:h-[293px] object-cover"
											/>
										))}
									</>
								) : (
									<>
										{dataChange.map((item: any, index: number) => (
											<NArticleCard data={item as StoryJson} key={index} />
										))}
									</>
								)}
							</>
						) : (
							<DataEmpty
								classNameIcon="w-[80px] h-[80px] min-w-[80px]"
								classNameText="text-lg font-medium"
								className="col-span-4"
								translateKey="story_collection_empty"
							/>
						)}
					</>
				)}
			</div>
			{menu.length > 0 &&
				dataChange.length > 0 &&
				showLoadMoreBtn &&
				!loading && (
					<span onClick={() => setLoading(true)}>
						<LoadMoreButton
							link={link}
							total={total}
							limit={limit}
							scroll={scroll}
							className="mx-auto mt-4"
						/>
					</span>
				)}
		</>
	);
}
